import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Content = ({ content, image, alt, cote, width, height }) => {
  useEffect(() => {
    // Initialisation de Fancybox
    Fancybox.bind("[data-fancybox]", {
    });
    // Nettoyage lors du démontage du composant
    return () => {
      Fancybox.destroy();
    };
  }, []);

  return (
    <div className={`container-content ${cote}`}>
      <div className="content markdown">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
      <div className="image">
        <a href={image.hd} data-fancybox="gallery" data-caption={alt}>
          <img src={image.thumb} alt={alt} loading="lazy" style={{ width: width || '100%', height: height || 'auto' }} />
        </a>
      </div>
    </div>
  );
};

export default Content;
